import { createItem } from 'common/api/panels';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { actions } from '../reducer';

import returnCatalog from './returnCatalog';

export default (filterData, values) => (dispatch) => {
    dispatch(actions[SAVE]());

    createItem(values)
        .then((response) => {
            dispatch(actions[SAVE_SUCCESS](response.data));

            dispatch(returnCatalog(filterData));
            showToast();
        })
        .catch((error) =>
            dispatch(actions[SAVE_FAILURE](error?.response?.data?.errors)),
        );
};
